<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      :width="width"
      :show-close="showClose"
      :close-on-click-modal="clickModal"
      :before-close="handleClose"
    >
      <!-- 插入内容 -->
      <div>
        <slot name="slotInfo"></slot>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    /* 标题 */
    title: {
      type: String,
      default: "提示",
    },
    /* 是否显示关闭按钮 */
    showClose: {
      type: Boolean,
      default: false,
    },
    /* 是否显示弹框 */
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "390px",
    },
    clickModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
      this.$emit("update:dialogVisible", this.dialogVisible);
      this.$emit("handleClose");
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-dialog__header {
  border-bottom: 1px solid #e5e5e5;
}

/deep/.el-dialog__title {
  font-weight: bold !important;
  color: #666666;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/bounced.vue